import { defineStore } from 'pinia'

export const useMenuStore = defineStore({
  id: 'menu',
  state: () => ({
    menuItems: [
      { id: 'about-us', path: '/about-us', label: 'menu.about-us' },
      { id: 'services', path: '/services', label: 'menu.services' },
      { id: 'events', path: '/events', label: 'menu.events' },
      { id: 'donations', path: '/donations', label: 'menu.donations' },
      { id: 'contacts', path: '/contacts', label: 'menu.contacts' }
      /*{
        id: 'guides', path: '/guides', label: 'menu.guides', items: [
          { id: '4c', path: '/guides/4c' }
        ]
      }*/
    ]
  }),
  actions: {}
})
